import { useState } from "react";
import APP_CONSTANTS from "../utils/config";

export default function useApi(apiFunction) {
  const [apiState, setApiState] = useState({
    status: APP_CONSTANTS.INITIAL,
    errorMessage: "",
    apiData: [],
  });

  const callApi = async (...args) => {
    try {
      setApiState((prev) => ({
        ...prev,
        status: APP_CONSTANTS.LOADING,
        errorMessage: "",
      }));

      const response = await apiFunction(...args);

      const statusCode = response.data?.status?.statusCode;

      const statusMessage = response.data?.status?.statusMessage || "";

      const responseData = response.data?.data ?? [];

      if (statusCode === "nam-200") {
        setApiState({
          status: APP_CONSTANTS.SUCCESS,
          errorMessage: "",
          apiData: responseData,
        });

        return {
          success: true,
          data: responseData,
        };
      }

      setApiState((prev) => ({
        ...prev,
        status: APP_CONSTANTS.ERROR,
        errorMessage: statusMessage,
      }));

      return {
        success: false,
        data: [],
      };
    } catch (err) {
      const errorData =
        err?.response?.data?.status?.message ||
        err?.response?.data ||
        err?.message ||
        "Something went wrong";

      setApiState((prev) => ({
        ...prev,
        status: APP_CONSTANTS.ERROR,
        errorMessage: errorData,
      }));

      return {
        success: false,
        data: [],
      };
    }
  };

  return {
    ...apiState,
    callApi,
  };
}
